import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";
import KeyboardButton from "@/components/tpv/OnScreenKeyboard";
import { inputCls } from "@/components/ui-kit";

export default function TextDialog({ open, title, initial, onClose, onSave, testid }) {
  const { t } = useApp();
  const [v, setV] = useState("");
  useEffect(() => { if (open) setV(initial || ""); }, [open, initial]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogTitle className="font-heading text-xl">{title}</DialogTitle>
        <div className="flex gap-2">
          <input autoFocus value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => e.key === "Enter" && onSave(v.trim())} className={inputCls} data-testid={`${testid}-input`} />
          <KeyboardButton value={v} onChange={setV} onEnter={() => onSave(v.trim())} testid={`${testid}-osk`} />
        </div>
        <button type="button" onClick={() => onSave(v.trim())} className="h-12 bg-[#3A6EA5] text-white font-bold uppercase text-sm" data-testid={`${testid}-save`}>{t("confirm")}</button>
      </DialogContent>
    </Dialog>
  );
}
